<template>
    <div :class="[twMerge('flex w-full flex-col px-7 py-2', $attrs['class'] as string)]">
        <div
            class="flex flex-row gap-6 pb-2 pl-4 pt-4"
            :class="{
                'border-b-2 border-b-ds-primary-500': withDivider,
            }"
        >
            <div class="flex flex-1 flex-row gap-1 align-middle text-lg font-bold text-content-primary">
                {{ title || '' }}
                <div
                    v-if="helperText"
                    v-tooltip.right="GEN_IDV_STYLED_TOOLTIP(helperText)"
                    class="inline-block p-1 text-sm"
                >
                    <FontAwesomeIcon
                        icon="fa-regular fa-circle-question"
                        size="sm"
                    />
                </div>
            </div>
            <div class="flex w-2/12 flex-row justify-end text-right">
                <CheckStateResult
                    v-if="sectionCheckResult"
                    class="text-lg font-bold"
                    :value="sectionCheckResult"
                />
            </div>
            <div
                v-if="collapsable"
                class="flex w-14 cursor-pointer items-center justify-end pr-1 text-xs text-ds-blue-500"
                @click="contentExpanded = !contentExpanded"
            >
                {{ contentExpanded ? 'Collapse' : 'Expand' }}
            </div>
        </div>

        <div v-if="contentExpanded">
            <slot v-if="sectionCheckResult?.state !== CheckResultState.NotFound"></slot>
            <CheckErrorList
                v-if="sectionCheckResult && !omitErrorList"
                :value="sectionCheckResult"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { CheckResult } from '@/api/interfaces/identity-verification-report.api';
import { CheckResultState } from '@/api/interfaces/identity-verification-report.api';
import { twMerge } from 'tailwind-merge';
import { ref } from 'vue';
import CheckErrorList from './CheckErrorList.vue';
import CheckStateResult from './CheckStateResult.vue';
import { GEN_IDV_STYLED_TOOLTIP } from './idv-helper-tooltip.pt';

const contentExpanded = ref(true);

withDefaults(
    defineProps<{
        sectionCheckResult?: CheckResult;
        title?: string;
        helperText?: string;
        omitErrorList?: boolean;
        withDivider?: boolean;
        collapsable?: boolean;
    }>(),
    {
        omitErrorList: false,
        withDivider: true,
        collapsable: true,
    },
);
</script>
